// extracted by mini-css-extract-plugin
module.exports = {"container":"description_container__25ml6","dashedBkg":"description_dashedBkg__Y2O_l","row":"description_row__Hn-FV"};